import { Sparkles, Instagram, Mail } from "lucide-react";
import { TESTIDS } from "@/constants/testIds";
import { SHOP_URL } from "@/data/content";

const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

export const Footer = () => (
  <footer data-testid={TESTIDS.footer.section} className="bg-white border-t border-ink/5 px-5 sm:px-8 py-16">
    <div className="mx-auto max-w-6xl grid md:grid-cols-3 gap-10">
      <div>
        <div className="flex items-center gap-2 font-display font-700 text-lg text-ink">
          <span className="grid place-items-center h-8 w-8 rounded-full bg-violet text-white">
            <Sparkles size={16} />
          </span>
          Justyna<span className="text-violet-deep"> Skowrońska</span>
        </div>
        <p className="mt-4 text-ink/50 max-w-xs leading-relaxed">
          Cyfrowe materiały edukacyjne zadedykowane nauczycielom i rodzicom dzieci w spektrum autyzmu.
        </p>
      </div>

      <div className="md:justify-self-center">
        <h4 className="font-600 text-ink mb-4">Nawigacja</h4>
        <ul className="space-y-2 text-ink/55">
          <li><button onClick={() => scrollTo("produkty")} className="hover:text-violet-deep transition-colors">Produkty</button></li>
          <li><button onClick={() => scrollTo("o-mnie")} className="hover:text-violet-deep transition-colors">O mnie</button></li>
          <li><button onClick={() => scrollTo("faq")} className="hover:text-violet-deep transition-colors">FAQ</button></li>
        </ul>
      </div>

      <div className="md:justify-self-end">
        <button
          data-testid={TESTIDS.footer.shopCta}
          onClick={() => scrollTo("produkty")}
          className="rounded-full bg-ink text-white font-500 px-7 py-3.5 hover:bg-violet-deep transition-colors duration-300"
        >
          Przejdź do sklepu
        </button>
        <a
          data-testid="footer-full-shop-link"
          href={SHOP_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-4 block text-sm font-500 text-ink/50 hover:text-violet-deep transition-colors"
        >
          Zobacz pełny sklep →
        </a>
        <div className="mt-6 flex gap-3">
          <a href="https://instagram.com/zglowawspektrum" target="_blank" rel="noopener noreferrer" aria-label="Instagram" data-testid="footer-instagram" className="grid place-items-center h-10 w-10 rounded-full bg-cream border border-ink/5 hover:text-violet-deep transition-colors"><Instagram size={18} /></a>
          <a href="mailto:justinaskylark@gmail.com" aria-label="E-mail" data-testid="footer-email" className="grid place-items-center h-10 w-10 rounded-full bg-cream border border-ink/5 hover:text-violet-deep transition-colors"><Mail size={18} /></a>
        </div>
      </div>
    </div>
    <div className="mx-auto max-w-6xl mt-12 pt-8 border-t border-ink/5 text-sm text-ink/40 flex flex-col sm:flex-row justify-between gap-2">
      <span>© 2026 Justyna Skowrońska. Wszelkie prawa zastrzeżone.</span>
      <span>Zaprojektowano z troską 💜</span>
    </div>
  </footer>
);
